import {
  Shirt,
  Utensils,
  ShoppingBasket,
  Home as HomeIcon,
  Plane,
  Sparkles,
  Globe,
  Heart,
  Dog,
  ShoppingBag,
  Store as StoreIcon,
  Fuel,
  Cpu,
  MonitorPlay,
  Code,
  Gamepad2,
  Banknote,
  GraduationCap,
  Tag,
} from "lucide-react";

export const CATEGORY_ICONS = {
  Fashion: Shirt,
  Food: Utensils,
  Grocery: ShoppingBasket,
  Home: HomeIcon,
  Travel: Plane,
  Beauty: Sparkles,
  Online: Globe,
  Health: Heart,
  Pets: Dog,
  Retail: ShoppingBag,
  Electronics: Cpu,
  Convenience: Fuel,
  Streaming: MonitorPlay,
  Software: Code,
  Gaming: Gamepad2,
  Finance: Banknote,
  Learning: GraduationCap,
  All: Tag,
};

export function iconFor(cat) {
  return CATEGORY_ICONS[cat] || Tag;
}
